import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";
import React, { FC, useCallback, useState } from "react";

import { useMatchParams } from "kanopi-components/hooks/useMatchParams";

type TGenericFlow = {
  prefix: string;
  finishedRoute?: string;
  actionQuery: object;
  questionFlowResponseKey: string;
  actionFlowType?: QuestionFlowTypeEnum;
  finalButtonText?: string;
  onComplete: (...args: unknown[]) => void;
};

export const GenericForwardFlow: FC<TGenericFlow> = ({
  prefix,
  finishedRoute = prefix,
  actionQuery,
  questionFlowResponseKey,
  actionFlowType = QuestionFlowTypeEnum.Quote,
  finalButtonText,
  onComplete,
}) => {
  const { questionSetKey } = useMatchParams(`${prefix}/:questionSetKey`);

  const [nextButtonText, setNextButtonText] = useState<string>();
  const onQuestionFlowFinish = useCallback(async () => {
    await onComplete?.();
  }, []);

  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _nextButtonText = currentSet === maxSets - 1 ? finalButtonText : undefined;
    setNextButtonText(_nextButtonText);
  };
  return (
    <QuestionFlowComponent
      isFlowLayout={false}
      actionFlowType={actionFlowType}
      prefix={prefix}
      finishedRoute={finishedRoute}
      defaultBackLocation=""
      actionQuery={actionQuery}
      questionFlowResponseKey={questionFlowResponseKey}
      questionSetKey={questionSetKey}
      onCurrentAndMaxSetChange={onCurrentMaxSetChange}
      nextButtonText={nextButtonText}
      onQuestionFlowFinish={onQuestionFlowFinish}
    />
  );
};
